import React from 'react';
import ReactDOM from 'react-dom/client';
import {
    createBrowserRouter,
    RouterProvider
} from "react-router-dom";
import PouchDB from "pouchdb-browser";
import { Provider } from "use-pouchdb";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RecoilEnv, RecoilRoot } from "recoil";
import { ConfirmProvider } from "material-ui-confirm";
import './index.css';
import App from './App';
import QSC from "./views/Qsc";

const queryClient = new QueryClient()
const localDB = new PouchDB('delfornoqsc', { revs_limit: 1 });

RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = false;

const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
    }, {
        path: "/qsc",
        element: <QSC />,
    }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <RecoilRoot>
            <Provider pouchdb={localDB}>
                <QueryClientProvider client={queryClient}>
                    <ConfirmProvider>
                        <RouterProvider router={router} />
                    </ConfirmProvider>
                </QueryClientProvider>
            </Provider>
        </RecoilRoot>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
